import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "messages" ]

  connect() {
    this.setScrollPosition();
    this.observer = new MutationObserver((mutations) => {
      const hasNewNodes = mutations.some(mutation =>
        mutation.type === "childList" && mutation.addedNodes.length > 0
      );

      if (hasNewNodes) {
        this.setScrollPosition();
      }
    })

    this.observer.observe(this.messagesTarget, {
      childList: true,
      subtree: true
    })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  setScrollPosition() {
    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight - this.messagesTarget.clientHeight
  }
}
